export default function FooterDashboard() {
  return (
    <footer className="footer d-flex flex-column flex-md-row align-items-center justify-content-between px-4 py-3 border-top small">
      <p className="text-muted mb-1 mb-md-0">
        Copyright © 2022{" "}
        <a href="../index.html" target="_blank">
          Travelin
        </a>
        .
      </p>
      <p className="text-muted">
        Powered By{" "}
        <i className="mb-1 text-primary ms-1 icon-sm" data-feather="heart" />{" "}
        Bizberg Themes
      </p>
    </footer>
  );
}
